module.exports = __webpack_public_path__ + "img/IMG-20200510-WA0004.bc5db161.jpg";